import React, { useEffect } from 'react';
import BoundingboxPhoto from '../images/BoundingBox.png';
import styled from 'styled-components';

const StyledContainer = styled.div`
width: 100%;
margin: auto;
padding: 10px 0px 10px 0px;
`;

const BoundingboxPage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontSize: "18px" }}>
        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Bounding Box
        </div>
        <div style={{ margin: '10px 0px' }}>
        Bounding Box can be changed at any time. After object added, you can adjust bounding box according to object's size. To change the bounding box, 
        right click <strong>BoundingBox</strong> node, then click <strong>Edit Bounding Box</strong> menu. In <strong>Edit Bounding Box</strong> dialog, 
        change grid size, and min/max grid number for X, Y, Z, then click <strong>OK</strong>.
        </div>

        <StyledContainer>
            <img src={BoundingboxPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

    </div>
  )
}

export default BoundingboxPage;